





















































































































































import { Component, Vue } from "vue-property-decorator";
import {
  getOptionList,
  getIncomeList,
  getSettlementList,
  getFreezeList,
} from "@/api/user/user";
import moment from "moment";
import { goTop } from "@/global/utils";
import Tab from "@/components/tab.vue";
@Component({
  components: {
    Tab,
  },
})
export default class Income extends Vue {
  private total: number = 0;
  private showSummary: Boolean = false;
  private tabsStatuesList: object[] = [
    {
      label: "可提现余额明细",
      value: "account",
    },
    {
      label: "待甲方确认额明细",
      value: "check",
    },
    {
      label: "冻结明细",
      value: "freeze",
    },
  ];

  private checkChange: object[] = [
    {
      value: "0",
      label: "增加",
    },
    {
      value: "1",
      label: "减少",
    },
  ];

  private sumFiled = new Set(["amount"]);

  private tabsList: object = {
    account: {
      sort: [
        {
          value: "IN",
          label: "收入",
        },
        {
          value: "OUT",
          label: "支出",
        },
      ],
      sortVal: "",
      types: [],
      typeVal: "",
      columns: [
        {
          title: "时间",
          key: "date",
          align: "center",
        },
        {
          title: "变动金额",
          slot: "amount",
          align: "center",
        },
        {
          title: "变动前可提现余额",
          slot: "available_amount",
          align: "center",
        },
        {
          title: "收支",
          slot: "balance",
          align: "center",
        },
        {
          title: "收入说明",
          key: "desc",
          align: "center",
        },
        {
          title: "类型",
          key: "type_name",
          align: "center",
        },
      ],
      data: [],
      paramsData: {
        etime: "",
        page: 1,
        pagesize: 20,
        stime: "",
      },
      fromData: {
        in_out: "",
        type: "",
        time: "",
      },
    },
    check: {
      typeVal: "",
      columns: [
        {
          title: "时间",
          key: "date",
          align: "center",
        },
        {
          title: "变动前",
          slot: "available_amount",
          align: "center",
        },
        {
          title: "变动金额",
          key: "change_amount",
          align: "center",
        },
        {
          title: "变动后",
          slot: "final_amount",
          align: "center",
        },
        {
          title: "变动说明",
          key: "desc",
          align: "center",
        },
      ],
      data: [],
      paramsData: {
        etime: "",
        page: 1,
        pagesize: 20,
        stime: "",
      },
      fromData: {
        time: "",
      },
    },
    freeze: {
      types: [
        {
          value: "SUPPLIER_WITHDRAW",
          label: "企业付款",
        },
        {
          value: "GUARANTEE_FREEZE",
          label: "保底计划冻结",
        },
      ],
      typeVal: "",
      columns: [
        {
          title: "时间",
          key: "date",
          align: "center",
        },
        {
          title: "金额",
          key: "amount",
          align: "center",
        },
        {
          title: "类型",
          key: "type",
          align: "center",
        },
        {
          title: "说明",
          key: "explain",
          align: "center",
        },
      ],
      data: [],
      paramsData: {
        etime: "",
        page: 1,
        pagesize: 20,
        stime: "",
      },
      fromData: {
        type: "",
        time: "",
      },
    },
  };
  private loading: boolean = true;
  private currentTag: string = "account";
  private currentData: object = {};
  private selectType = "";
  private created() {
    this.getInitDate();
    this.getOption();
    this.currentData = (this.tabsList as any).account;
    this.getIncomeData({ ...this.initParams("account") });
    goTop();
  }
  // 获取当前时间到上个月今天
  private getInitDate() {
    const dateTime = [];
    const now = moment().format("YYYY-MM-DD");
    const last = moment(new Date()).subtract(1, "months").format("YYYY-MM-DD");
    dateTime.push(last);
    dateTime.push(now);
    return dateTime;
  }
  // 切换tag
  private changeTag(type: string) {
    this.currentTag = type;
    this.showSummary = true;
    switch (type) {
      case "account":
        this.currentData = (this.tabsList as any)[type];
        (this.currentData as any).fromData = {
          in_out: "",
          type: "",
          time: "",
        };
        this.showSummary = false;
        this.getIncomeData({ ...this.initParams("account") });
        break;
      case "check":
        this.currentData = (this.tabsList as any)[type];
        (this.currentData as any).fromData = {
          time: "",
        };
        this.showSummary = false;
        this.getSettlement({ ...this.initParams("check") });
        break;
      case "freeze":
        this.currentData = (this.tabsList as any)[type];
        (this.currentData as any).fromData = {
          type: "",
          time: "",
        };
        this.getFreeze({ ...this.initParams("freeze") });
        break;
      default:
        break;
    }
    goTop();
  }
  private initParams(type) {
    const initDate = this.getInitDate();
    this.selectType = type;
    if (type === "account" || type === "freeze") {
      const paramsData = (this.tabsList as any)[type].paramsData;
      paramsData.etime = initDate[1];
      paramsData.stime = initDate[0];
      paramsData.page = 1;
      paramsData.pagesize = 20;
      (this.tabsList as any)[type].fromData.time = initDate;
      return paramsData;
    } else if (type === "check") {
      const paramsData = (this.tabsList as any)[type].paramsData;
      paramsData.etime = initDate[1];
      paramsData.stime = initDate[0];
      paramsData.page = 1;
      paramsData.pagesize = 20;
      (this.tabsList as any)[type].fromData.time = initDate;
      return paramsData;
    }
  }
  // 获取选项item
  private async getOption() {
    try {
      const res = await getOptionList();
      const result = res as any;
      const tabsList = this.tabsList as any;
      const itemArr = [];
      result.rows.forEach((item, index) => {
        itemArr.push({
          label: item.name,
          value: item.code,
        });
      });
      tabsList.account.types = itemArr;
    } catch (err) {
      console.log(err);
    }
  }
  // 获取账目数据
  private async getIncomeData(option) {
    try {
      this.loading = true;
      const res = await getIncomeList(option);
      const result = res as any;
      const currentData = this.currentData as any;
      result.rows.map((item, index) => {
        item.date = moment(item.date).format("YYYY-MM-DD HH:mm:ss");
      });
      
      // 表尾合计行（1 || 2 行）
      if (Array.isArray(result.footer)) {
        result.footer.forEach(item => {
          item.date = item.time
          item.in_out = item.amount / 100 + '元'
          item.amount = ''
        })
        result.rows = result.rows.concat(result.footer)
      }
      currentData.data = result.rows;
      this.total = result.total;
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }
  // 获取验收额
  private async getSettlement(option) {
    try {
      this.loading = true;
      const res = await getSettlementList(option);
      const result = res as any;
      const currentData = this.currentData as any;
      result.rows.map((item, index) => {
        item.date = moment(item.time * 1000).format("YYYY-MM-DD HH:mm:ss");
        if (item.in_out == 0) {
          item.final_amount = item.available_amount + item.amount;
          item.change_amount = "+" + item.amount / 100 + "元";
        } else {
          item.final_amount = item.available_amount - item.amount;
          item.change_amount = "-" + item.amount / 100 + "元";
        }
      });
      // 表尾合计行（1 || 2 行）
      if (Array.isArray(result.footer)) {
        result.footer.forEach(item => {
          item.date = item.time
          item.change_amount = item.amount / 100 + '元'
        })
        result.rows = result.rows.concat(result.footer)
      }
      currentData.data = result.rows;
      this.total = result.total;
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }
  // 获取冻结明细
  private async getFreeze(option) {
    try {
      this.loading = true;
      const res = await getFreezeList(option);
      const result = res as any;
      const currentData = this.currentData as any;
      result.rows.map((item, index) => {
        item.date = moment(item.date).format("YYYY-MM-DD HH:mm:ss");
      });
      currentData.data = result.rows;
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }

  // 查询
  private handleSubmit(name) {
    (this.$refs[name] as any).validate((valid) => {
      if (this.currentTag === "account") {
        const { in_out, time, type } = (this.currentData as any).fromData;
        const paramsData = (this.currentData as any).paramsData;
        Object.assign(paramsData, {
          in_out,
          type,
        });
        if (time && time[0] && time[1]) {
          Object.assign(paramsData, {
            stime: moment(time[0]).format("YYYY-MM-DD HH:mm:ss"),
            etime: moment(time[1]).format("YYYY-MM-DD HH:mm:ss"),
          });
        }

        this.getIncomeData(paramsData);
      } else if (this.currentTag === "check") {
        const paramsData = (this.currentData as any).paramsData;
        const { time, vid, in_out } = (this.currentData as any).fromData;
        Object.assign(paramsData, {
          in_out,
          vid,
        });
        if (!vid) {
          delete paramsData.vid;
        }

        if (!in_out) {
          delete paramsData.in_out;
        }
        if (time && time[0] && time[1]) {
          Object.assign(paramsData, {
            stime: moment(time[0]).format("YYYY-MM-DD"),
            etime: moment(time[1]).format("YYYY-MM-DD"),
          });
        }

        this.getSettlement(paramsData);
      } else {
        const { time, type } = (this.currentData as any).fromData;
        const paramsData = (this.currentData as any).paramsData;
        Object.assign(paramsData, {
          type,
        });
        if (time && time[0] && time[1]) {
          Object.assign(paramsData, {
            stime: moment(time[0]).format("YYYY-MM-DD HH:mm:ss"),
            etime: moment(time[1]).format("YYYY-MM-DD HH:mm:ss"),
          });
        }
        this.getFreeze(paramsData);
      }
    });
  }
  // 重置
  private handleReset(name) {
    //    (this.$refs[name] as any).resetFields();
    (this.$refs[name] as any).fields.forEach((e: any) => {
      if (e.prop !== "group") {
        e.resetField();
      }
    });
  }

  // 切换页面
  private changePage(num: number) {
    (this.currentData as any).paramsData.page = num;
    if (this.currentTag === "account") {
      this.getIncomeData((this.currentData as any).paramsData);
    } else if (this.currentTag === "check") {
      this.getSettlement((this.currentData as any).paramsData);
    } else {
      this.getFreeze((this.currentData as any).paramsData);
    }
    goTop();
  }

  private getSummaries({ columns, data }) {
    const sums = {};
    columns.forEach((column, index) => {
      let key = column.key;
      if (index === 0) {
        sums[key] = {
          key,
          value: "合计",
        };
        return;
      }
      let sumKey = key == "change_amount" ? "amount" : key;
      const values = data.map((item) => Number(item[sumKey]));

      if (!values.every((value) => isNaN(value))) {
        try {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: v / 100 + " 元",
          };
        } catch (e) {}
      } else {
        sums[key] = {
          key,
          value: "",
        };
      }
    });
    return sums;
  }

  getRowClassName(row) {
    if(row.date === '初验总金额' || row.date === '甲方总结算' || row.date === '收入总计') {
      return 'row-sum'
    }
  }
}
